export const DIRECTORIES = {
  PLAYLIST: '/playlist',
  SEE_ALL: '/playlist/tag/:tagId',
  GENRE: '/genre',
  SESSION_END: '/session-end',
};

export const CUSTOM_PLAYLIST_BASE = `${DIRECTORIES.PLAYLIST}/custom`;

export const PATHS = {
  HOME: '/home',
  PLAYLIST: `${DIRECTORIES.PLAYLIST}/:playlistId`,
  GENRE: `${DIRECTORIES.GENRE}/:genreId`,
  CUSTOM_PLAYLIST: `${CUSTOM_PLAYLIST_BASE}/:playlistId`,
  PLAYER: '/player',
  DESKTOP_PLAYER: '/desktop-player',
  STAFF: '/',
  SESSION: '/session',
  SETTINGS: '/settings',
  CATALOG: '/catalog',
  CATALOG_PULIC: '/catalog/:roomId',
  SESSION_END: `${DIRECTORIES.SESSION_END}`,
  PLAYER_SESSION_END: `${DIRECTORIES.SESSION_END}/player`,
  CLIENT_CODE: '/client_code',
  LIGHTS: '/lights',
  EFFECTS: '/effects',
  SONG_LIST: '/song-list',
};
